export default __webpack_public_path__ + "cfcc08a936fa648bfcef3f28b2d98285.svg";